export default "__VITE_ASSET__DVjFC3FA__"